import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import SeventhFlow from 'components/Flows/SeventhFlows/SeventhFlows';
import SeventhAnalysisDrawer from 'components/Analyses/SeventhAnalyses/Drawer/Drawer';

const SeventhFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <SeventhAnalysisDrawer />
      <SeventhFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SeventhFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);